import { all, put, takeLatest } from 'redux-saga/effects';
import {
  GET_COUNTRIES,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_FAILED,
  GET_STATES,
  GET_STATES_SUCCESS,
  GET_STATES_FAILED,
  GET_CITIES,
  GET_CITIES_SUCCESS,
  GET_CITIES_FAILED,
  GET_CITIES_BY_STATE_ID,
  GET_CITIES_BY_STATE_ID_SUCCESS,
  GET_CITIES_BY_STATE_ID_FAILED,
} from './constants';
import * as LocationActions from './action';
import Api from '../../commons/api';

const controllerStates = 'states';
const controllerCities = 'cities';

function* getStates() {
  try {
    const { data } = yield Api.get(`${controllerStates}/${controllerStates}/`);
    yield put(LocationActions.getStatesSuccess(data));
  } catch (err) {
    console.log('error', err);
    yield put(LocationActions.getStatesFailed(err));
  }
}

function* getCities() {
  try {
    const { data } = yield Api.get(`${controllerCities}/${controllerCities}/`);
    yield put(LocationActions.getCitiesSuccess(data));
  } catch (err) {
    console.log('error', err);
    yield put(LocationActions.getCitiesFailed(err));
  }
}
function* getCitiesByStateId({ payload }) {
  try {
    const { data } = yield Api.get(
      `${controllerCities}/${controllerCities}/city-state/${payload.stateId}`,
    );
    console.log('cities', data);
    yield put(LocationActions.getCitiesByStateIdSuccess(data));
  } catch (err) {
    console.log('error', err);
    yield put(LocationActions.getCitiesByStateIdFailed(err));
  }
}

function* ActionWatcher() {
  yield takeLatest(GET_STATES, getStates);
  yield takeLatest(GET_CITIES, getCities);
  yield takeLatest(GET_CITIES_BY_STATE_ID, getCitiesByStateId);
}

export default function* LocationSaga() {
  yield all([ActionWatcher()]);
}
